import { ReactNode } from 'react';
import {
  CursorProvider,
  EditorProvider,
  HandleProvider,
  KeyboardProvider,
  MouseProvider,
} from './useEditor';
import { ElementsProvider } from './useElements';
import { SceneProvider } from './useScene';

export const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <EditorProvider>
      <MouseProvider>
        <KeyboardProvider>
          <HandleProvider>
            <CursorProvider>
              <ElementsProvider>
                <SceneProvider>{children}</SceneProvider>
              </ElementsProvider>
            </CursorProvider>
          </HandleProvider>
        </KeyboardProvider>
      </MouseProvider>
    </EditorProvider>
  );
};
